module.exports = __webpack_public_path__ + "img/okta-logo.2661b82e.png";